module.exports = __webpack_public_path__ + "static/img/footerp.09f5554.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/footerp.png
// module id = lA3/
// module chunks = 16